import { inject, injectable } from "@launchtray/tsyringe-async";
import { SceneManager } from "../../../../../../scene/SceneManager";
import { ICheckoutHourlyBonusController } from "./ICheckoutHourlyBonusController";
import { HourlyBonusSceneFactory } from "../../HourlyBonusFactories";
import { HourlyBonusState } from "../../mainHourlyBonus/HourlyBonusState";
import { CancellationToken } from "async/CancellationToken";
import { IContextResolver } from "by/gamefactory/cityversetycoon/composition/IContextResolver";
import { ILogger } from "by/gamefactory/cityversetycoon/logger/ILogger";
import { AsyncOperationNotification } from "by/gamefactory/cityversetycoon/scenes/common/components/AsyncOperationNotification";

@injectable()
export class CheckoutHourlyBonusController implements ICheckoutHourlyBonusController {
    private readonly contextResolver: IContextResolver;
    private readonly sceneManager: SceneManager;
    private readonly asyncOperationNotification: AsyncOperationNotification;
    private readonly logger: ILogger;

    public constructor(
        @inject("IContextResolver") contextResolver: IContextResolver,
        sceneManager: SceneManager,
        asyncOperationNotification: AsyncOperationNotification,
        @inject("ILogger") logger: ILogger
    ) {
        this.contextResolver = contextResolver;
        this.sceneManager = sceneManager;
        this.asyncOperationNotification = asyncOperationNotification;
        this.logger = logger;
    }

    public async showFortuneWheelScene(cancellationToken: CancellationToken): Promise<void> {
        try {
            this.asyncOperationNotification.show();
            const factory: HourlyBonusSceneFactory = await this.contextResolver.resolve("HourlyBonusSceneFactory");
            if (cancellationToken.isCancellationRequested) {
                return;
            }
            const scene = await factory({ state: HourlyBonusState.DEFAULT, cancellationToken });
            if (cancellationToken.isCancellationRequested) {
                scene.view?.destroy();
                return;
            }
            this.asyncOperationNotification.hide();
            await this.sceneManager.showViewableAsync(scene);
        }
        catch (error: unknown) {
            this.logger.error("Exception on show HourlyBonus: ", error);
        }
        finally {
            this.asyncOperationNotification.hide();
        }
    }
}